// extracted by mini-css-extract-plugin
export default {"subPageContainer":"xaoSTAA2NK0l7i462moH","subPageContainerMobile":"OkbkSeMMUWtgjp2kBwmU"};